export enum RegEx {
  LabelFormat = '[a-zA-Z0-9]+[.][a-zA-Z0-9]+'
}
